# TODO: deprecate this file

module.exports =
  articleSelections: require './article_selections'
  exploreUnits: require './explore_units'
  messages: require './messages'
  permissionforms: require './permissionforms'
  routing: require './routing'
  session: require './session'
